import { useEffect, useState } from "react";
import Header from "../components/Header/Header"
import { ThankContent } from "../components/ThankContent/ThankContent"
import { getThankYou } from "../components/helpers/Api";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";

export const ThankYou = () => {

    const [searchParams] = useSearchParams();
    const serviceID = searchParams.get('ServiceID');
    const orderID = searchParams.get('OrderID');
    const hash = searchParams.get('Hash');
    const [dateAdd, setDateAdd] = useState('');
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [id, setId] = useState('');
    const [orderStatus, setOrderStatus] = useState('');
    const navigate = useNavigate();


    // Если нет хотя бы одного параметра — редирект на главную

    useEffect(() => {

        // Если нет параметров - редирект с заменой истории
        if (!serviceID || !orderID || !hash) {
            window.history.replaceState({}, '', '/');
            navigate('/', { replace: true });
            return;
        }

        getThankYou({
            service_id: serviceID,
            order_id: orderID,
            hash: hash
        }).then((res) => {
            // console.log(res.data.data);
            setDateAdd(res.data.data.date_add)
            setLastName(res.data.data.lastname);
            setFirstName(res.data.data.firstname);
            setId(res.data.data.id);
            setOrderStatus(res.data.data.order_status)
        })
            .catch((error) => {
                // Редирект с очисткой истории
                // console.log(error);
                if (error) {
                    window.history.replaceState({}, '', '/');
                    navigate('/', { replace: true });
                }

            });
    }, [searchParams, serviceID, orderID, hash, navigate]);

    // Дополнительная защита на случай, если параметры исчезнут после рендера
    if (!serviceID || !orderID || !hash) {
        return <Navigate to="/" replace />;
    }


    return (
        <>
            <Header />
            <ThankContent date_add={dateAdd} firstname={firstName} lastname={lastName} id={id} order_status={orderStatus} />
        </>
    )
}